<template>
  <div v-if="show"
       v-bind:id="id"
       ref="app"
       class="rotating-mowgli"
       v-bind:class="styleClass">
    <small v-if="label"
           class="mowgli-label"
           v-bind:class="{'mowgli-absolute-label': labelPosition == 'absolute'}">
      {{ label }}
    </small>
    <a v-if="isImage"
       v-bind:href="href"
       v-on:click="handleClick(value)"
       v-bind:rel="value.banner.nofollow ? 'nofollow' : ''"
       v-bind:target="target">
      <img v-bind:src="fileDomain + '/' + value.creative.img"
           v-bind:width="width"
           v-bind:height="height"/>
    </a>
    <div v-if="isHtml5">
      <iframe v-bind:src="fileDomain + '/banner/' + value.creative.html"
              v-bind:width="width"
              v-bind:height="height"
              seamless="seamless"
              scrolling="no"
              border="0"
              v-bind:style="'display: block; border: 0;'"
              class="mowgli-iframe">
      </iframe>
      <div v-if="value.creative.clickOverlay" class="banner-overlay">
        <a v-bind:href="href"
           v-on:click="handleClick(value)"
           v-bind:rel="value.banner.nofollow ? 'nofollow' : ''"
           v-bind:target="target"></a>
      </div>
    </div>
    <template v-if="isScript && width != null && width >= 0 && height != null && height >= 0">
      <iframe v-bind:src="sSrc"
              v-bind:width="width"
              v-bind:height="height"
              seamless="seamless"
              scrolling="no"
              border="0"
              v-bind:style="'display: block; border: 0;'"
              class="mowgli-iframe">
      </iframe>
    </template>
    <template v-if="value.banner.trackingScript">
      <iframe v-bind:src="tsSrc"
              v-bind:width="1"
              v-bind:height="1"
              seamless="seamless"
              scrolling="no"
              border="0"
              v-bind:style="'position: absolute; display: block; border: 0;'"
              class="mowgli-iframe">
      </iframe>
    </template>
  </div>
</template>

<script>
import Vue from "vue"
import MediaWidth from "../plugins/media-width"
import Track from "../plugins/track"
Vue.use(MediaWidth)
Vue.use(Track)
export default {
  name: "banner",
  props: ["id", "value", "label", "label-position", "rendered"],
  data: function () {
    return {
      contextPath: window.contextPath,
      fileDomain: window.fileDomain,
      fullContainer: 1,
      standardContainer: 2,
      mediaWidth: Vue.$mediaWidth(),
      width: null,
      height: null,
      resizing: false,
      impression: false,
      viewableImpression: false,
      consent: false,
      consentData: null
    };
  },
  created: function () {
    var instance = this;
    window.EventBus.register("banner-consent-is-ready", function () {
      var hidden = !instance.show;
      instance.consent = window["banner-consent-is-ready"] ? window["banner-consent-is-ready"] : false;
      instance.consentData = window["banner-consent-data"];
      if (hidden) {
        instance.$nextTick(function () {
          // $(window).resize(); // this resize event is solely so we can reposition the sticky banners after a top banner renders, which only happens during next tick
          window.fireWindowResizeEvent();
        });
      }
    });
    instance.consent = window["banner-consent-is-ready"] ? window["banner-consent-is-ready"] : false;
    instance.consentData = window["banner-consent-data"];
  },
  mounted: function () {
    this.setWidthAndHeight();
    // Check if we can count impression and viewable impression right away. This mostly applies to image banners,
    // since they are the simplest and fastest to render.
    this.handleImpression();
    this.checkViewable();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  updated: function () {
    this.setWidthAndHeight();
    this.checkViewable();
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    isReady: function () {
      return this.width > 0 && this.height > 0 && this.show;
    },
    isImage: function () {
      return !!this.value.creative.img;
    },
    isHtml5: function () {
      return !!this.value.creative.html;
    },
    isScript: function () {
      return !!this.value.creative.script;
    },
    styleClass: function () {
      const classes = [];
      if (this.isReady && !this.resizing) {
        switch (this.value.creative.container) {
          case this.fullContainer:
            classes.push("base-container");
            classes.push("full");
            break;
          case this.standardContainer:
            classes.push("base-container");
            classes.push("xs-no-padding");
            break;
        }
        classes.push("ready");
      } else {
        classes.push("initializing");
      }
      return classes.join(" ");
    },
    target: function () {
      return this.value.banner.href.trim().indexOf("mailto:") == 0 ? "" : "_blank";
    },
    reinitOnAnyResize: function () {
      return this.value.creative.container == this.fullContainer;
    },
    widthAndHeight: function () {
      return {
        width: this.width,
        height: this.height
      };
    },
    href: function () {
      if (this.value && this.value.banner && this.value.banner.href) {
        var href = this.value.banner.href;
        return this.replaceConsentTags(href, this.value.banner.hrefVendorId);
      }
      return "";
    },
    sSrc: function () {
      if (this.value && this.value.banner && this.value.creative) {
        var src = this.contextPath + '/bnrscr?id=' + this.value.banner.id + '&creative=' + this.value.creative.id + '&width=' + this.width + '&height=' + this.height;
        return this.appendConsentParams(src, this.value.creative.scriptVendorId);
      }
      return "";
    },
    tsSrc: function () {
      if (this.value && this.value.banner) {
        var src = this.contextPath + '/bnrtsscr?id=' + this.value.banner.id;
        return this.appendConsentParams(src, this.value.banner.trackingScriptVendorId);
      }
      return "";
    },
    show: function () {
      return (!this.isHtml5 && !this.isScript && (!this.value.banner.trackingScript || this.value.banner.trackingScript.length == 0)) || this.consent || window.testMode;
    }
  },
  methods: {
    handleResize: function () {
      var mw = Vue.$mediaWidth();
      if (this.mediaWidth != mw || mw == "xs" || this.reinitOnAnyResize) {
        this.mediaWidth = mw;
        this.checkViewable();
        this.resizing = true;
        this.$nextTick(() => {
          this.setWidthAndHeight();
          this.resizing = false;
        });
      }
    },
    handleScroll: function () {
      this.checkViewable();
    },
    handleClick: function () {
      this.handleViewableImpression();
      this.$track("click_" + this.mediaWidth, "banner", this.value.banner.id);
    },
    handleImpression: function () {
      if (!this.impression) {
        this.impression = this.$track("impression_" + this.mediaWidth, "banner", this.value.banner.id);
      }
    },
    handleViewableImpression: function () {
      if (!this.viewableImpression) {
        this.viewableImpression = this.$track("viewable_impression_" + this.mediaWidth, "banner", this.value.banner.id);
      }
    },
    isViewable: function () {
      var rect = this.getAppRect();
      if (rect) {
        var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        var left = rect.left < 0 ? 0 : rect.left > viewWidth ? viewWidth : rect.left;
        var top = rect.top < 0 ? 0 : rect.top > viewHeight ? viewHeight : rect.top;
        var right = rect.right < 0 ? 0 : rect.right > viewWidth ? viewWidth : rect.right;
        var bottom = rect.bottom < 0 ? 0 : rect.bottom > viewHeight ? viewHeight : rect.bottom;
        var half = rect.width * rect.height * 0.5;
        var visible = (right - left) * (bottom - top);
        return visible > half;
      }
      return false;
    },
    checkViewable: function () {
      var instance = this;
      var valid = function () {
        return !instance.viewableImpression
            && instance.isViewable();
      };
      setTimeout(function () {
        if (valid()) {
          setTimeout(function () {
            if (valid()) {
              instance.handleViewableImpression();
            }
          }, 1000);
        }
      }, 0);
    },
    setWidthAndHeight: function () {
      var width = this.value.creative.width;
      var height = this.value.creative.height;

      var rect = this.getAppRect();
      if (rect) {
// Force the scroll bar.
        if (this.value.creative.container == this.fullContainer) {
          document.body.className += " mowgli-scrollbar";
        }

        var availableWidth = rect.width;

// Un-force the scroll bar.
        if (this.value.creative.container == this.fullContainer) {
          var list = document.body.className.split(" ");
          var className = "";
          for (var i = 0; i < list.length; i++) {
            if (list[i] != "mowgli-scrollbar") {
              className += list[i] + " ";
            }
          }
          document.body.className = className;
        }

        if (width > availableWidth) {
          height = height * (availableWidth / width);
          width = availableWidth;
        } else if (this.value.creative.container == this.fullContainer && width < availableWidth) {
          height = height * (availableWidth / width);
          width = availableWidth;
        }
      }

      this.width = Math.round(width);
      this.height = Math.round(height);
    },
    replaceConsentTags: function (str, vendorId) {
      if (vendorId && !isNaN(vendorId)) {
        try {
          if (this.consentData) {
            if (this.consentData.gdprApplies) {
              str = str.replace("${gdpr}", this.consentData.gdprApplies);
            }
            if (this.consentData.tcString) {
              str = str.replace("${gdpr_consent_" + vendorId + "}", this.consentData.tcString);
            }
          }
        } catch (err) {
          throw "v1error\n" + JSON.stringify(this.consentData) + "\n" + str + "\n" + err;
        }
      }
      return str;
    },
    appendConsentParams: function (url, vendorId) {
      if (vendorId && !isNaN(vendorId)) {
        url += "&vendorId=" + vendorId;
        try {
          if (this.consentData) {
            if (this.consentData.gdprApplies) {
              url += "&gdprApplies=" + this.consentData.gdprApplies;
            }
            if (this.consentData.tcString) {
              url += "&tcString=" + this.consentData.tcString;
            }
          }
        } catch (err) {
          throw "v1error\n" + JSON.stringify(this.consentData) + "\n" + url + "\n" + err;
        }
      }
      return url;
    },
    getAppRect: function () {
      if ("app" in this.$refs) {
        var element = this.$refs["app"];
        if (typeof element !== "undefined") {
          return element.getBoundingClientRect();
        }
      }
      return null;
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      var newId = newValue && newValue.banner ? newValue.banner.id : null;
      var oldId = oldValue && oldValue.banner ? oldValue.banner.id : null;
      if (newId != oldId) {
        // If the banner changes, reset impression and viewable impression and check impressions and viewable impression again.
        this.impression = false;
        this.viewableImpression = false;
        this.handleImpression();
        this.checkViewable();
      }
    },
    widthAndHeight: function (newValue) {
      var instance = this;
      if (instance.rendered) {
        var width = newValue && newValue.width >= 0 ? newValue.width : null;
        var height = newValue && newValue.height >= 0 ? newValue.height : null;
        if (typeof instance.rendered == "function") {
          instance.$nextTick(function () {
            instance.rendered(width, height);
          });
        } else if (typeof instance.rendered == "string") {
          var fn = window[instance.rendered];
          if (typeof fn == "function") {
            instance.$nextTick(function () {
              fn(width, height);
            });
          }
        }
      }
    },
    isReady: function (newValue) {
      // This is mostly for counting impressions and viewable impressions on slow rendering banners. HTML and scripts
      // banners. But also banners embedded in dynamic content that cause them to render late or slow.
      if (newValue) {
        this.$nextTick(() => {
          this.handleImpression();
          this.checkViewable();
        });
      }
    }
  }
}
</script>
